import { createReducer } from 'lib/utilities.js';

const initialState = {
  facebookAdCampaigns: [],
  facebookAdCampaignsCompareData: [],
  facebookCampaignsLoadState: true,
  facebookCampaignsDailyLoadState: true,
  facebookCampaignAdSetLoadState: true,
  facebookCampaignAdsSetPreviewLoadState: true,
  facebookCampaignsDailyData: [],
  facebookCampaignsDailyDataCompare: [],
  selectedGraphTypeFacebookCampaigns: 'impressions',
  facebookCampaignAdSet: [],
  facebookCampaignAdSetPreview: [],
  selectedAdSetCreatives: undefined,
  adSetPreviewModalVisible: false,
  selectedFacebookAdCampaign: null,
};

export default createReducer(initialState, {
  setFacebookDailyDataLoadState: (state, payload) => ({
    ...state,
    facebookCampaignsDailyLoadState: payload,
  }),
  setFacebookCampaignsLoadState: (state, payload) => ({
    ...state,
    facebookCampaignsLoadState: payload,
  }),
  fetchingFacebookAdCampaigns_SUCCESS: (state, payload) => ({
    ...state,
    facebookAdCampaigns: payload,
  }),
  fetchingFacebookAdCampaignsCompareData_SUCCESS: (state, payload) => {
    return {
      ...state,
      facebookAdCampaignsCompareData: payload,
    };
  },
  setGraphTypeFacebookCampaigns: (state, payload) => ({
    ...state,
    selectedGraphTypeFacebookCampaigns: payload,
  }),

  fetchFBCampaignStatsDaily_SUCCESS: (state, payload) => {
    return {
      ...state,
      facebookCampaignsDailyData: payload,
      facebookCampaignsDailyLoadState: false,
    };
  },
  resetFacebookCampaignStats: (state, payload) => {
    return {
      ...state,
      facebookCampaignsDailyDataCompare: payload,
      facebookCampaignsDailyLoadState: false,
      facebookAdCampaignsCompareData: payload,
    };
  },
  fetchFBCampaignStatsDailyForCompare_SUCCESS: (state, payload) => {
    return {
      ...state,
      facebookCampaignsDailyDataCompare: payload,
      facebookCampaignsDailyLoadState: false,
    };
  },
  setFacebookAdsSetLoadState: (state, payload) => ({
    ...state,
    facebookCampaignAdSetLoadState: payload,
  }),
  fetchFacebookCampaignAdSet_SUCCESS: (state, payload) => {
    return {
      ...state,
      facebookCampaignAdSet: payload,
      facebookCampaignAdSetLoadState: false,
    };
  },
  fetchFacebookCampaignAdSetPreview_SUCCESS: (state, payload) => {
    const copy = [...(state.facebookCampaignAdSetPreview || []), payload.data];
    let unique = [...new Set(copy)];
    return {
      ...state,
      facebookCampaignAdSetPreview: unique,
      facebookCampaignAdsSetPreviewLoadState: false,
    };
  },
  clearFacebookAdSetPreviews: (state, payload) => {
    return {
      ...state,
      facebookCampaignAdSetPreview: undefined,
    };
  },
  setFacebookAdSetCreatives: (state, payload) => {
    return {
      ...state,
      selectedAdSetCreatives: payload,
    };
  },
  setAdSetPreviewModeVisibility: (state, payload) => {
    return {
      ...state,
      adSetPreviewModalVisible: payload,
    };
  },
  setFacebookCampaignId: (state, payload) => {
    return {
      ...state,
      selectedFacebookAdCampaign: payload.data,
    };
  },
});
